import { Controller } from '@hotwired/stimulus';
import { formatLocalDatetime } from '../lib/datetime_formatter.mjs';

const FORMATS = {
  short: {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  },
};

export default class extends Controller {
  static values = {
    locale: String,
    format: { type: String, default: 'short' },
  };

  connect() {
    const instant = new Date(this.element.dateTime);
    const options = FORMATS[this.formatValue];

    if (Number.isNaN(instant.valueOf()) || !options) return;

    this.element.textContent = formatLocalDatetime(
      instant,
      this.localeValue,
      this.formatValue,
      options,
    );
  }
}
